$(document).ready(function () {
    if (onLoadExecute && onLoadExecute.length > 0) {
        for (var i = 0; i < onLoadExecute.length; i++) {
            if ($.isFunction(onLoadExecute[i])) {
                onLoadExecute[i]();
            }
        }
    }
    $(".navbar-collapse-onhover>ul>li").on("mouseenter", function (e) {
        $(this).addClass("open");
    }).on("mouseleave", function (e) { 
        $(this).removeClass("open");
        });
    $(".navbar-collapse-onhover a.dropdown-toggle").on("click", function (e) {
        e.preventDefault();
        window.location.href = $(this).attr("href");
    });
    $("[data-select-on-click]").selectOnClick();
});